import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchCustomFieldsForImport } from '../../actions';
import { dataImportConfig } from '../../template-configuration';

// Import types that include the Holder's Project Custom Fields.
const CUSTOM_FIELD_TEMPLATE_TYPES = [2, 4];

class DownloadTemplateModalContent extends Component {
  state = { selected: '', customFields: [] };

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  handleChange = (e) => {
    this.setState({ selected: e.target.value });
  };

  handleDownload = async () => {
    const typeId = parseInt(this.state.selected, 10);
    if (!typeId) return;

    // Custom fields are fetched fresh on every download so that added, renamed,
    // archived or reordered fields are reflected immediately.
    let customFields = this.state.customFields;
    if (CUSTOM_FIELD_TEMPLATE_TYPES.includes(typeId)) {
      customFields = await this.props.dispatch(fetchCustomFieldsForImport(this.props.holderId));
      if (this._isMounted) {
        this.setState({ customFields: customFields || [] });
      }
    }

    const fieldDefinitions = dataImportConfig.getTemplateFieldDefinitions(typeId, customFields);
    
    const headers = dataImportConfig.getTemplateHeaders(typeId, customFields);

    if (fieldDefinitions.length === 0 || headers.length === 0) {
      alert('Invalid import type');
      return;
    }

    const previousData = this.props.data || [];
    const matchingImports = previousData.filter(item => item.importTypeID === typeId);
    const firstMeta = matchingImports[0] || {};

    const rows = [];

    const csvRows = [headers.join(',')];

    rows.forEach(row => {
      const values = [
        ...fieldDefinitions.map(field => row[field.key] || ''),
        // ...extraHeaders.map(col => firstMeta[col] || '')
      ];
      const escaped = values.map(v => `"${String(v).replace(/"/g, '""')}"`);
      csvRows.push(escaped.join(','));
    });

    const csvContent = csvRows.join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = dataImportConfig.getTemplateFilename(typeId);
    link.click();
    window.URL.revokeObjectURL(url);

    this.props.onClose();
  };

  render() {
    const { templateTypes, onClose, tabs } = this.props;
    const { title, selectLabel, selectPlaceholder, downloadBtnText} = tabs.dataImports.downloadModal;
    const { selected } = this.state;
    const hasSelection = !!selected;

    return (
      <div className="add-entity-form-small download-data-modal-container">
        <div className="add-item-header">
          <h1>{title}</h1>
        </div>

        <section className="white-section">
          <div className="add-item-form-subsection">
            <div className="form-group">
              <label className='label'>{selectLabel}</label>
              <select
                className={`form-control ${!selected ? 'is-placeholder' : ''}`}
                value={selected}
                onChange={this.handleChange}
                placeholder={selectPlaceholder}
              >
                <option className='is-placeholder' value="">{selectPlaceholder}</option>
                {templateTypes.map(type => (
                  <option key={type.id} value={type.id}>
                    {type.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="add-item-bn text-right mt-4">
              <button className="bn bn-small cancel-add-item mr-2" onClick={onClose}>
                Cancel
              </button>
              <button
                className="bn bn-small bg-green-dark-gradient create-item-bn"
                onClick={this.handleDownload}
                disabled={!hasSelection}
              >
                {downloadBtnText}
              </button>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  tabs: state.localization.strings.holders.holdersProfile.tabs,
  holderId: state.holdersProfile.profileData.id || null,
});

export default connect(mapStateToProps)(DownloadTemplateModalContent);